import styled from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexColumn } from '@/styles/common';

export const Wrapper = styled.div<{ $isWrapperPadding?: boolean }>`
  ${flexColumn};
  min-height: 100vh;
  padding-top: 58px;
  @media (min-width: ${BREAKPOINTS.desktop}) {
    padding-top: 80px;
  }

  @media (max-width: ${BREAKPOINTS.tablet}) {
    padding-top: ${({ $isWrapperPadding }) =>
      $isWrapperPadding ? '0' : '58px'};
  }
`;

export const MainContent = styled.main`
  flex: 1;
  ${flexColumn}
`;

export const SecondaryHeaderWrapper = styled.div`
  max-height: 58px;
  background-color: var(--bg-main);
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
`;
